import React from 'react';

const BlurOverlay = () => {
  return <div className="blur-overlay"></div>;
};

export default BlurOverlay;

